import { render, staticRenderFns } from "./PokerPots.vue?vue&type=template&id=f61b4b7e&scoped=true&"
import script from "./PokerPots.vue?vue&type=script&lang=js&"
export * from "./PokerPots.vue?vue&type=script&lang=js&"
import style0 from "./PokerPots.vue?vue&type=style&index=0&id=f61b4b7e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f61b4b7e",
  null
  
)

export default component.exports